module.exports = __webpack_public_path__ + "media/images/icons/ambassador_orange-c873727c47f215cde70ba5d817f17cd2.svg";